<template>
  <div class="completed">
    <h1>Количество пройденных и назначенных заданий</h1>
    <div class="completed_student">
      <div class="completed_student-info">
        <div class="completed_student-info-personal">
          <img class="personal-photo" :src="getPhotoUrl(student)" />
          <div class="personal-name">{{ student.fio }}</div>
        </div>
        <div class="completed_student-info-study">
          <div class="student-course">
            <p class="txt-left">Курс</p>
            <p class="txt-right">{{ student.studyCourseName }}</p>
          </div>
          <div class="student-group">
            <p class="txt-left">Группа</p>
            <p class="txt-right">{{ student.groupName }}</p>
          </div>
        </div>
        <div class="completed_student-info-study">
          <div class="student-course">
            <p class="txt-left">Факультет</p>
            <p class="txt-right">{{ student.facultyName }}</p>
          </div>
        </div>
        <div class="completed_student-info-study">
          <div class="student-course">
            <p class="txt-left">Организация</p>
            <p class="txt-right">{{ student.organizationName }}</p>
          </div>
        </div>
        <div class="completed_student-tasks">
          <p>Количество пройденных и назначенных заданий:</p>
          <div class="completed_student-tasks-number"><span>{{ student.completeCount }}</span>/<span>{{ student.activateCount }}</span></div>
        </div>
      </div>
    </div>
    <div class="filter-block">
      <div style="width:200px" class="filter-item">
        <h3 class="filter-item-name">Тип теста</h3>
            <v-autocomplete
                class="filter-item-combobox"
                outlined
                dense
                :items="testTypes.list"
                v-model="testTypes.selected"
                item-value="id"
                item-text="name"
                @change="update"
                hide-details
                placeholder="Все"
                clearable
                multiple
            ></v-autocomplete>
      </div>
      <div style="width:270px" class="filter-item">
        <h3 class="filter-item-name">Дисциплина</h3>
            <v-autocomplete
                class="filter-item-combobox"
                outlined
                dense
                :items="subjects.list"
                item-value="id"
                item-text="name"
                @change="update"
                v-model="subjects.selected"
                hide-details
                placeholder="Все"
                clearable
                multiple
            ></v-autocomplete>
      </div>
      <div style="width:270px" class="filter-item">
        <h3 class="filter-item-name">Тема</h3>
            <v-autocomplete
                class="filter-item-combobox"
                outlined
                dense
                :items="topics.list"
                v-model="topics.selected"
                item-value="id"
                item-text="name"
                hide-details
                @change="update"
                placeholder="Все"
                clearable
                multiple
            ></v-autocomplete>
      </div>
      <div class="filter-item">
        <h3 class="filter-item-name">Срок сдачи</h3>
          <div class="filter-item-date">
              <span>от</span>
              <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  v-model="dates.begin.menu"
                  min-width="auto"
              >
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-bind="attrs"
                          v-on="on"
                          :value="dates.begin.formatted"
                          class="filter-item-combobox"
                          readonly
                          dense
                          @input="inputDate($event, dates.begin)"
                          outlined
                          hide-details
                          prepend-icon="mdi-calendar"
                          placeholder="__.__.____"
                          clearable
                      />
                  </template>
                  <v-date-picker
                  :min="dates.min"
                  :max="dates.end.value !== null ? dates.end.value : dates.max"
                  v-model="dates.begin.value"
                  @input="inputDate($event, dates.begin)"
                  no-title
                  scrollable
                  />
              </v-menu>
            </div>
      </div>
      <div style="margin-top:30px;" class="filter-item">
        <div class="filter-item-date">
            <span>до</span>
            <v-menu
                :close-on-content-click="false"
                v-model="dates.end.menu"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        class="filter-item-combobox"
                        outlined
                        dense
                        :value="dates.end.formatted"
                        @input="inputDate($event, dates.end)"
                        hide-details=""
                        clearable
                        readonly
                        prepend-icon="mdi-calendar"
                        placeholder="__.__.____"
                    />
                </template>
                <v-date-picker
                :min="dates.begin.value !== null ? dates.begin.value : dates.min"
                :max="dates.max"
                v-model="dates.end.value"
                @input="inputDate($event, dates.end)"
                no-title
                scrollable
                />
            </v-menu>
        </div>
      </div>
      <div style="width: 200px;" class="filter-item">
        <h3 class="filter-item-name">Статус</h3>
            <v-autocomplete
                class="filter-item-combobox"
                outlined
                :items="statusTests.list"
                v-model="statusTests.selected"
                item-value="id"
                item-text="name"
                dense
                hide-details=""
                @change="update"
                placeholder="Все"
                clearable
                multiple
            ></v-autocomplete>
      </div>

    </div>
    <div ref="taskList" class="tasks_list">
      <div v-for="(task, index) in tests" :key="index" class="completed_task">
        <div class="completed_task-wrap">
          <div class="completed_task-info">
            <!-- <div class="completed_task-details"> -->
              <div class="completed_task-active">
                <div class="txt-wrap">
                  <p>Тип задания</p>
                  <p>{{ getTestTypeName(task.testType) }}</p>
                </div>
                <div class="txt-wrap">
                  <p>Наименование задания</p>
                  <p>{{ task.title }}</p>
                </div>
                <div class="txt-wrap">
                  <p>Дисциплина</p>
                  <p>{{ task.studyDisciplineName }}</p>
                </div>
                <div class="txt-wrap">
                  <p>Тема</p>
                  <p>{{ task.studyTopicName }}</p>
                </div>
                <div class="txt-wrap">
                  <p>Статус выполнения</p>
                  <p>{{ getStatusText(task) }}</p>
                </div>
              </div>
              <div class="completed_task-dates">
                <div class="txt-wrap">
                  <p>Срок сдачи</p>
                  <p>{{ new Date(task.dateFrom).toLocaleDateString('ru-RU')}} – {{ new Date(task.dateTo).toLocaleDateString('ru-RU') }}</p>
                </div>
                <div class="txt-wrap">
                  <p>Повторное прохождение</p>
                  <p>{{ task.isRepeat ? 'Да' : 'Нет' }}</p>
                </div>
              </div>
              <div class="completed_task-result">
                <div class="completed_task-result-time-wrap">
                  <div class="time">
                    <p>Последняя дата прохождения </p>
                    <p>{{ `${task.passDate ? (new Date(task.passDate)).toLocaleDateString('ru-RU') : '–'}` }}</p>
                  </div>
                </div>
                <div
                  class="completed_task-result-rating-wrap"
                  :class="{'noRating': task.lastScore === null}"
                  :style="task.lastScore != null ? `background: ${getScoreColor(task.lastScore)}` : ''">
                  <div class="rating">
                    <p>Последний результат</p>
                    <p>{{ `${task.lastScore !== null ? task.lastScore : '–'}` }}</p>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          </div>
          <div class="completed_task-btns">
            <v-btn
              @click="cancelTest(task)"
              :disabled="task.lastScore !== null || (loading.cancel && loading.id !== task.id)"
              :loading="loading.cancel && loading.id === task.id"
            >
              Удалить
            </v-btn>
            <v-btn
              @click="showResult(task)"
              :disabled="task.lastScore == null || (loading.result && loading.id !== task.testId)"
              :loading="loading.result && loading.id === task.testId"
            >
              Результаты
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div class="data-footer">
          <div class="pagination" v-if="params.pageSize != allItemsSize">
              <span>Cтраница:</span>
              <div @click.prevent="paginationPrev()" class="pagination_prev" :class="{ 'disabled': params.currentPage === 0 }">
                  <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                  </svg>
              </div>
              <div class="pagination_number">
                  {{ params.currentPage + 1 }}
              </div>
              <div v-if="params.pageSize" @click.prevent="paginationNext()" class="pagination_next" :class="{ 'disabled': params.currentPage === (pagesCount - 1) }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                  </svg>
              </div>
          </div>
          <div class="items-per-page">
              <span>Выводить:</span>
              <div class="items-per-page_drop">
                  <v-menu>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              color="white"
                              v-bind="attrs"
                              v-on="on"
                          >
                              <span>{{ params.pageSize != allItemsSize ? params.pageSize : 'Все' }}</span>
                              <div class="drop-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                  </svg>
                              </div>
                          </v-btn>
                      </template>
                      <v-list>
                          <v-list-item
                              v-for="(item, index) in pageSizes"
                              :key="index"
                              @change="updatePageSize(item.size)"
                          >
                              <v-list-item-title>{{ item.name }}</v-list-item-title>
                          </v-list-item>
                      </v-list>
                  </v-menu>
              </div>
          </div>
      </div>
    </template>
    <LearningResultDialog ref="learningResultDialog" @loaded="loading.result = false" />
    <DiagnosticsResultDialog ref="diagnosticsResultDialog" @loaded="loading.result = false" />
    <TimeoutSnackbar :options="snackbar" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { helpers } from '@/store/tests';
import LearningResultDialog from '../../Shared/TestResultDialog/Learning/index.vue';
import DiagnosticsResultDialog from '../../Shared/TestResultDialog/Diagnostics/index.vue';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import './index.scss';
const AllItemsSize = 1000;
export default {
  components: { LearningResultDialog, DiagnosticsResultDialog, TimeoutSnackbar },
  data() {
    return {
      loadingTask: false,
        testTypes: {
            list: [],
            selected: [],
            searchInput: ''
        },
        subjects: {
            list: null,
            selected: [],
            searchInput: ''
        },
        topics: {
            all: [],
            list: null,
            selected: [],
            searchInput: ''
        },
        dates: {
            begin: {
                value: null,
                formatted: null,
                menu: false
            },
            end: {
                value: null,
                formatted: null,
                menu: false
            },
            min: null,
            max: null
        },
        calendarNudge: 0,
        status: {
            list: [],
            selected: [],
            searchInput: ''
        },
      student: {},
      tests: [],
      statusTests: {
        list: [
        {
          id: '0',
          name:'Назначено'

        },
        {
          id: '1',
          name:'Пройдено'

        },
        {
          id: '2',
          name:'Просрочено'

        }
         ],
            selected: [],
            searchInput: ''
      },
      totalCount: 0,
      pagesCount: 0,
        allItemsSize: AllItemsSize,
        pageSizes: [
            { name: '5', size: 5 },
            { name: '10', size: 10 },
            { name: '15', size: 15 },
            { name: 'Все', size: AllItemsSize }
        ],
      params: {
          filters: [],
          pageSize: 10,
          currentPage: 0,
          useANDoperator: true,
          columns: []
      },
      snackbar: {
        show: false,
        text: null,
        color: null,
        timeout: -1
      },
      loading: {
        id: null,
        cancel: false,
        result: false
      }
    }
  },
  computed: {
    ...mapGetters({
      apiUrl: 'apiUrl',
      apiImg: 'apiImg'
    })
  },
  methods: {
    loadStudent() {
      this.$http.get(`${this.apiUrl}Student/Get?id=${this.$route.params.id}`)
        .then((response) => {
          this.student = response.data;
      });
    },
    loadFilters() {
      this.$http.get(`${this.apiUrl}api/SprStudyDiscipline/GetAll`)
        .then((result) => {
          this.subjects.list = this.sortArray(result.data, 'name');
      });

      this.$http.get(`${this.apiUrl}api/SprDisciplineTopic/GetTopicsWithDisciplines`)
        .then((result) => {
          this.topics.all = result.data;
          this.topics.list = this.sortArray(this.topics.all, 'name');
      });

      for (let i = 0; i < helpers.testTypes.length; i++) {
        this.testTypes.list.push({ id: i.toString(), name: helpers.testTypes[i] });
      }
    },
    getPhotoUrl(student) {
      if (student.logoUrl) {
        return `${this.apiImg}${student.logoUrl}`;
      }

      return student.gender === 1 ? require('@/assets/img/avatar-boy.png') : require('@/assets/img/avatar-girl.png');
    },
    inputDate(value, date) {
            console.log(value, date);
            date.value = value;
            date.formatted = this.formatDate(date.value);
            console.log(date.formatted);
            date.menu = false;
            this.update();
        },
        formatDate(date) {
            if (!date) {
                return null;
            }

            const [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`;
        },
    getStatusText(task) {
      switch (task.statusId) {
        case 0: return 'Назначено';
        case 1: return 'Пройдено';
        case 2: return 'Просрочено';
        default: return '';
      }
    },
    updatePageSize(size) {
      this.params.currentPage = 0;
      this.params.pageSize = size;
      this.loadTask(this.params.filters);
    },
    paginationPrev() {
      this.params.currentPage = this.params.currentPage == 0 ? this.params.currentPage : --this.params.currentPage;
      this.loadTask(this.params.filters);
    },
    paginationNext() {
      this.params.currentPage = this.params.currentPage == (this.totalCount - 1) ? this.params.currentPage : ++this.params.currentPage;
      this.loadTask(this.params.filters);
    },
    getTestTypeName(type) {
        return helpers.testTypes[type];
    },
    sortArray(array, name) {
      return array.sort((a, b) => {
        if (a[name] < b[name]) {
          return -1;
        }

        if (a[name] > b[name]) {
          return 1;
        }

        return 0;
      })
    },
    update() {
      this.params.filters = [];

      if (this.testTypes.selected.length > 0) {
        this.params.filters.push({
          fieldName: 'testType',
          filterType: 9,
          filterValueType: 2,
          values: this.testTypes.selected
        });

        this.testTypes.searchInput = '';
      }

      if (this.dates.begin.value !== null) {
        this.params.filters.push({
          fieldName: 'dateFrom',
          filterType: 4,
          filterValueType: 1,
          value1: this.dates.begin.value
        });
      }

      if (this.dates.end.value !== null) {
        this.params.filters.push({
          fieldName: 'dateTo',
          filterType: 5,
          filterValueType: 1,
          value1: this.dates.end.value
        });
      }

      if (this.subjects.selected.length > 0) {
        this.params.filters.push({
          fieldName: 'disciplineId',
          filterType: 9,
          filterValueType: 1,
          values: this.subjects.selected
        });

        this.subjects.searchInput = '';

        let filteredTopics = this.topics.all
          .filter(x => this.subjects.selected
          .some(y => x.disciplineIds.includes(y)));

        this.topics.list = this.sortArray(filteredTopics, 'name');
        this.topics.selected = this.topics.selected.filter(x => filteredTopics.map(y => y.id).includes(x));
      } else {
        this.topics.list = this.sortArray(this.topics.all, 'name');
      }

      if (this.topics.selected.length > 0) {
        this.params.filters.push({
          fieldName: 'topicId',
          filterType: 9,
          filterValueType: 1,
          values: this.topics.selected
        });

        this.topics.searchInput = '';
      }

      if (this.statusTests.selected.length > 0) {
        this.params.filters.push({
          fieldName: 'statusId',
          filterType: 9,
          filterValueType: 1,
          values: this.statusTests.selected
        });

        this.topics.searchInput = '';
      }

      this.loadTask(this.params.filters);
    },
    getScoreColor(score) {
      if (score === null) return 'none';
      return helpers.getScoreColor(score);
    },
    loadTask(filters) {
      this.$http.post(`${this.apiUrl}Student/GetTeacherViewTests?studentId=${this.$route.params.id}`, {
        columns: this.params.columns,
        sortOption: this.params.sortOption,
        currentPage: this.params.currentPage,
        filters: filters,
        pageSize: this.params.pageSize,
        useANDoperator: this.params.useANDoperator
      })
      .then((result) => {
        this.tests = result.data.data
        this.totalCount = this.params.pageSize ? Math.ceil(result.data.totalRecords / this.params.pageSize) : 1;
      });
    },
    cancelTest(task) {
      this.snackbar = { show: false };

      if (!confirm("Вы действительно хотите отменить это задание?")) {
        return;
      }

      this.loading.id = task.id;
      this.loading.cancel = true;

      this.$http.delete(`${this.apiUrl}Student/CancelTest?assignId=${task.id}&testType=${task.testType}`)
        .then(() => {
          this.tests = this.tests.filter(x => x.id !== task.id);
          this.loadStudent();
          this.loading.id = null;
          this.loading.cancel = false;

          this.snackbar = {
            text: 'Задание отменено',
            color: 'success',
            timeout: 5000,
            show: true
          };
        }, () => {
          this.loading.id = null;
          this.loading.cancel = false;

          this.snackbar = {
            text: 'Произошла ошибка. Задание не было отменено.',
            color: 'error',
            timeout: -1,
            show: true
          };
        });
    },
    showResult(task) {
      this.loading.id = task.testId;
      this.loading.result = true;

      if (task.testType === 0) {
        this.$refs.learningResultDialog.reset(this.student.id, task.testId, null);
      } else if (task.testType === 1) {
        let input = {
          assignId: task.id,
          resultId: null
        };
        this.$refs.diagnosticsResultDialog.reset(input);
      }
    }
  },
  created() {
    this.loadStudent();
    this.loadFilters();
    this.loadTask([]);
  }
}
</script>
<style scoped lang="scss">
    .filter-item {
        align-self: center;
        margin-left: 20px;
        width: 200px;
        .filter-item-name {
            margin-bottom: 4px;
            color: #2B2D33;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 26px; /* 185.714% */
        }
        .filter-item-combobox {
            width: 100%;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px; /* 157.143% */
            border-radius: 8px;
        }
        .filter-item-date {
            width: 100%;
            display: flex;
            gap: 10px;
            span {
                margin-top: 10px;
                color: #AAAEB7;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }
        }
    }
</style>
